import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

if (
  window.location.search.includes('leadId') ||
  window.location.hash.includes('message-')
) {
  sessionStorage.setItem('preAuthUrl', window.location.href);
}

// Bootstrap components
import 'bootstrap/dist/css/bootstrap.min.css';
const msalInstance = new PublicClientApplication(msalConfig);

import TagManager from 'react-gtm-module';

TagManager.initialize({
  gtmId: 'GTM-M6R7PZGN',
});

const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(
  // <React.StrictMode>
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
